import React from 'react'
import { isMobile } from 'react-device-detect'
import ReactPlayer from 'react-player'
import { Link, useParams } from 'react-router-dom'
import { GetSamplePostResponse } from 'apis/door/PostV1'
import DefaultUserIcon from 'images/default_user_icon.jpg'
import { dateConvertiongForView } from 'utils/Datetime'
import LinkfiedContent from 'components/door/room/LinkfiedContent'
import PlayIcon from 'images/play_icon.svg'
import { ImagesPreview } from 'components/door/room/ImagePreview'
import { SamplePostFilesPreview } from 'components/door/room/FilePreviews'
import styled from 'styled-components'
import LockIcon from '@material-ui/icons/Lock'

import ShareButtonView from 'components/common/ShareButtonView'

interface Props {
  samplePost: GetSamplePostResponse | undefined
  mediaClass: Array<string>
  isPreview?: boolean
}

export default function SamplePostDetail({
  samplePost,
  mediaClass,
  isPreview
}: Props) {
  const { door_id } = useParams<{
    door_id: string
  }>()

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isPreview) {
      event.preventDefault()
    }
  }

  // @ts-ignore
  return (
    <div>
      {samplePost && (
        <SamplePostWrap>
          <SamplePostTitle>{samplePost.title}</SamplePostTitle>

          <SamplePostInfo>
            <SamplePostOwnerImageWithName>
              <Link
                to={`/door/${samplePost.poster.twitter_screen_name}`}
                onClick={handleClick}
              >
                <SamplePostOwnerImage
                  src={
                    samplePost.poster.icon_image_url
                      ? samplePost.poster.icon_image_url
                      : DefaultUserIcon
                  }
                  alt=""
                />
              </Link>
              <Link
                to={`/door/${samplePost.poster.twitter_screen_name}`}
                onClick={handleClick}
              >
                <SamplePostOwnerName>
                  {samplePost.poster.door_screen_name}
                </SamplePostOwnerName>
              </Link>
            </SamplePostOwnerImageWithName>
            <SamplePostCreatedAtWithShareButton>
              <SamplePostCreatedAt>
                {dateConvertiongForView(samplePost.post_created_at)}
              </SamplePostCreatedAt>
              <SamplePostShare>
                <ShareButtonView
                  // PostShareButtonがデザイン実装段階で使われずこちらのコンポーネントなので維持。
                  // 投稿詳細のシェアボタンと同じ見た目にするため、ドア名に投稿タイトルをいれる。
                  ownerName={samplePost.owner.name}
                  doorName={samplePost.title}
                  description={samplePost.content}
                />
              </SamplePostShare>
            </SamplePostCreatedAtWithShareButton>
          </SamplePostInfo>

          <div>
            <SamplePostImage>
              {samplePost.attached_files.images &&
                samplePost.attached_files.images.length > 0 && (
                  <ImagesPreviewWrap>
                    {samplePost.is_restricted && <StyledLockIcon />}
                    <ImagesPreview
                      images={[samplePost.attached_files.images[0]]}
                    />
                  </ImagesPreviewWrap>
                )}
              {samplePost.status === 'wait_for_encode' && (
                <div>
                  <span>動画処理中です</span>
                  <br />
                  この投稿は処理完了後に投稿されます
                </div>
              )}
            </SamplePostImage>
            <div>
              <SamplePostFilesPreview
                attachedFiles={samplePost.attached_files}
                canDownload={false}
              />
            </div>
            <div>
              {samplePost.is_restricted ? (
                <SamplePostImage>
                  <ImagesPreviewWrap>
                    {samplePost.is_restricted &&
                      samplePost.attached_files.videos.length > 0 && (
                        <>
                          <VideoPlayIcon src={PlayIcon} />
                          <ImagesPreview
                            images={samplePost.attached_files.videos.map(
                              (video, index) => {
                                return {
                                  id: index,
                                  url: video.url?.replace(
                                    '.m3u8',
                                    '.0000000.jpg'
                                  )
                                }
                              }
                            )}
                          />
                        </>
                      )}
                  </ImagesPreviewWrap>
                </SamplePostImage>
              ) : (
                samplePost.status === 'published' &&
                samplePost.attached_files.videos.map((video) => (
                  <ReactPlayer
                    key={video.url}
                    url={video.url}
                    controls
                    width="100%"
                    height={isMobile ? '250px' : '375px'}
                    className="mb3"
                    playsinline
                    light={video.url?.replace('.m3u8', '.0000000.jpg')}
                    playing={false}
                    playIcon={<img src={PlayIcon} />}
                    onClick={(e: any) => {
                      e.stopPropagation()
                    }}
                    config={{
                      file: {
                        hlsOptions: {
                          xhrSetup: function (xhr: any, url: any) {
                            xhr.withCredentials = true // send cookies
                          }
                        }
                      }
                    }}
                  />
                ))
              )}
            </div>
            <SamplePostText>
              <LinkfiedContent content={samplePost.content} doorId={door_id} />
            </SamplePostText>
          </div>
        </SamplePostWrap>
      )}
    </div>
  )
}

const SamplePostWrap = styled.div`
  margin: 0 auto 16px;
`

const SamplePostTitle = styled.h2`
  color: #333333;
  font-size: 22px;
  font-weight: bold;
  margin-top: 22px;
  margin-bottom: 48px;
  @media (max-width: 640px) {
    margin-top: 12px;
    margin-bottom: 24px;
  }
`
const SamplePostOwnerImageWithName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
const SamplePostOwnerImage = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 100%;
`
const SamplePostOwnerName = styled.p`
  color: #333333;
  font-size: 16px;
`

const SamplePostInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    gap: 16px;
  }
`
const SamplePostCreatedAtWithShareButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
  @media (max-width: 640px) {
    gap: 8px;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
`
const SamplePostCreatedAt = styled.p`
  color: #666666;
  font-size: 12px;
`
const SamplePostShare = styled.div`
  ul {
    display: flex;
    align-items: center;
    gap: 8px;
    .share-list-item {
      & + .share-list-item {
        margin: 0;
      }
      .share-link {
        width: 24px;
        height: 24px;
        @media (max-width: 640px) {
          width: 32px;
          height: 32px;
        }
        img {
          width: 24px;
          height: 24px;
          @media (max-width: 640px) {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
`
const SamplePostText = styled.div`
  color: #333;
  font-size: 16px;
`
const ImagesPreviewWrap = styled.div`
  position: relative;
`
const StyledLockIcon = styled(LockIcon)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: auto !important;
  height: 80px;
  color: #fff;
`
const SamplePostImage = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto 48px;
  @media (max-width: 640px) {
    margin: 0 auto 24px;
  }
  .media {
    width: 230px;
    height: 128px;
    overflow: hidden;
    margin-top: 0;
    img {
      width: 230px;
      height: 128px;
      object-fit: cover;
    }
  }
`

const VideoPlayIcon = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: auto !important;
  height: 40px;
  color: #fff;
  /* color: #1c1c1c; */
`
